'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _isNan = require('babel-runtime/core-js/number/is-nan');

var _isNan2 = _interopRequireDefault(_isNan);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// the radius of the handles
// RangeSlider

var HANDLE_RADIUS = 15;

var curryComputePosition = function curryComputePosition(width) {
  return function (distance) {
    return 100 * distance / width + '%';
  };
};
var curryComputeValue = function curryComputeValue(width, max, min) {
  return function (distance) {
    return Math.floor(min + (max - min) * (distance / width));
  };
};

function computeWidthByValue(_ref) {
  var max = _ref.max,
      min = _ref.min,
      _ref$high = _ref.high,
      high = _ref$high === undefined ? max : _ref$high,
      _ref$low = _ref.low,
      low = _ref$low === undefined ? min : _ref$low;

  return 100 * (high - low) / (max - min) + '%';
}

function getDimensions(props) {
  var max = props.max;

  var min = props.min && !(0, _isNan2.default)(props.min) ? props.min : 1;
  var high = props.high,
      low = props.low;

  high = !high || (0, _isNan2.default)(high) || high > max ? max : high;
  low = !low || (0, _isNan2.default)(low) || low < min ? min : low;
  if (low > high) {
    low = high;
  }

  return {
    // the position of the slider relative to the document body
    track: {
      left: 0,
      right: 0,
      width: 0
    },
    // the position of the handles relative to the document body
    handle: {
      left: 0,
      right: 0
    },
    // the ratio of the selected range relative to the slider
    position: {
      left: low ? 100 * (low - min) / (max - min) + '%' : '0%',
      right: high ? 100 * (high - min) / (max - min) + '%' : '100%',
      width: low || high ? computeWidthByValue({ max: max, min: min, high: high, low: low }) : '100%'
    },
    // the values after dragging
    values: {
      left: low,
      right: high
    }
  };
}

var RangeSlider = function (_Component) {
  (0, _inherits3.default)(RangeSlider, _Component);

  function RangeSlider(props) {
    (0, _classCallCheck3.default)(this, RangeSlider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RangeSlider.__proto__ || (0, _getPrototypeOf2.default)(RangeSlider)).call(this, props));

    var max = props.max,
        min = props.min,
        high = props.high,
        low = props.low;

    var dimensions = getDimensions({ max: max, min: min, high: high, low: low });
    _this.formatter = new Intl.NumberFormat(props.lang.replace('_', '-'));

    _this.state = (0, _extends3.default)({}, dimensions, {
      isDragging: false,
      // the handle being dragged
      draggingTarget: 'left'
    });

    _this.onMove = _this.onMove.bind(_this);
    _this.onDragEnd = _this.onDragEnd.bind(_this);
    _this.onResize = _this.onResize.bind(_this);
    return _this;
  }

  // checking element position is only available after the component is rendered
  /* eslint react/no-did-mount-set-state: "off" */


  (0, _createClass3.default)(RangeSlider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.onResize();

      document.addEventListener('mousemove', this.onMove);
      document.addEventListener('touchmove', this.onMove);
      document.addEventListener('mouseup', this.onDragEnd);
      document.addEventListener('touchend', this.onDragEnd);
      window.addEventListener('resize', this.onResize);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var max = _ref2.max,
          min = _ref2.min,
          high = _ref2.high,
          low = _ref2.low;

      if (this.props.max === max && this.props.min === min && this.props.high === high && this.props.low === low) {
        return;
      }

      var dimensions = getDimensions({ max: max, min: min, high: high, low: low });
      this.setState((0, _extends3.default)({}, dimensions));
      this.onPropsUpdate({ max: max, min: min, high: high, low: low }, dimensions);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // If the bar was invisible, the positions of track and handles were 0
      // we need to update the positions when it becomes visible
      if (this.props.isVisible && this.state.track.left === this.state.track.right) {
        this.onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousemove', this.onMove);
      document.removeEventListener('touchmove', this.onMove);
      document.removeEventListener('mouseup', this.onDragEnd);
      document.removeEventListener('touchend', this.onDragEnd);
      window.removeEventListener('resize', this.onResize);
    }

    // When max, min, high or low are updated from props

  }, {
    key: 'onPropsUpdate',
    value: function onPropsUpdate(props, state) {
      var _ref3 = [props.max, state.values.right, state.values.left],
          max = _ref3[0],
          high = _ref3[1],
          low = _ref3[2];

      var min = props.min || 1;
      var rect = this.track.getBoundingClientRect();
      var boundary = { left: rect.left, right: rect.right };
      var width = boundary.right - boundary.left;
      this.setState({
        track: (0, _extends3.default)({}, boundary, { width: width }),
        handle: {
          left: low ? boundary.left + width * ((low - min) / (max - min)) : boundary.left,
          right: high ? boundary.left + width * ((high - min) / (max - min)) : boundary.right
        }
      });

      return boundary;
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(e) {
      var clientX = e.clientX || e.touches[0].clientX;
      // out of the slider boundary
      if (clientX < this.state.track.left - HANDLE_RADIUS || clientX > this.state.track.right + HANDLE_RADIUS) {
        return;
      }
      // set dragging target
      var target = clientX < (this.state.handle.left + this.state.handle.right) / 2 ? 'left' : 'right';

      this.setState({
        isDragging: true,
        draggingTarget: target
      });
      // update the position and value of the target
      this.update(target, clientX);
    }
  }, {
    key: 'onMove',
    value: function onMove(e) {
      if (this.state.isDragging) {
        this.update(this.state.draggingTarget, e.clientX || e.touches[0].clientX);
      }
    }
  }, {
    key: 'onDragEnd',
    value: function onDragEnd() {
      if (this.state.isDragging) {
        this.setState({ isDragging: false });
        this.props.onChange(this.state.values.left, this.state.values.right);
      }
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      if (!this.props.isVisible) {
        return;
      }
      var boundary = this.onPropsUpdate(this.props, this.state);

      this.computePosition = curryComputePosition(boundary.right - boundary.left);
      this.computeValue = curryComputeValue(boundary.right - boundary.left, this.props.max, this.props.min);
    }
  }, {
    key: 'update',
    value: function update(target, x) {
      var left = void 0;
      var right = void 0;
      var distance = void 0;

      if (target !== 'right') {
        left = x > this.state.handle.right ? this.state.handle.right : x < this.state.track.left ? this.state.track.left : x;
        right = this.state.handle.right;
        distance = left;
      } else {
        left = this.state.handle.left;
        right = x < this.state.handle.left ? this.state.handle.left : x > this.state.track.right ? this.state.track.right : x;
        distance = right;
      }

      var range = right - left;
      var _state = this.state,
          handle = _state.handle,
          position = _state.position,
          values = _state.values;

      var state = _lodash2.default.cloneDeep({ handle: handle, position: position, values: values });
      state.handle[target] = distance;
      state.position[target] = this.computePosition(distance - this.state.track.left);
      state.position.width = this.computePosition(range);
      state.values[target] = this.computeValue(distance - this.state.track.left);
      this.setState(state);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          unit = _props.unit;


      var left = this.formatter.format(this.state.values.left);
      var right = this.formatter.format(this.state.values.right);

      return _react2.default.createElement(
        'div',
        { className: 'filter-price' },
        _react2.default.createElement(
          'div',
          { className: 'filter-title' },
          title
        ),
        _react2.default.createElement(
          'div',
          { className: 'filter-items' },
          _react2.default.createElement(
            'div',
            {
              className: 'filter-slider',
              onMouseDown: function onMouseDown(e) {
                return _this2.onDragStart(e);
              },
              onTouchStart: function onTouchStart(e) {
                return _this2.onDragStart(e);
              }
            },
            _react2.default.createElement(
              'div',
              { className: 'filter-slider-track' },
              _react2.default.createElement(
                'div',
                { className: 'slider-track', ref: function ref(node) {
                    _this2.track = node;
                  } },
                _react2.default.createElement('div', { style: { left: this.state.position.left, width: this.state.position.width }, className: 'slider-selection' }),
                _react2.default.createElement('div', { style: { left: this.state.position.left }, className: 'slider-handle', ref: function ref(node) {
                    _this2.leftHandle = node;
                  } }),
                _react2.default.createElement('div', { style: { left: this.state.position.right }, className: 'slider-handle', ref: function ref(node) {
                    _this2.rightHandle = node;
                  } })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'slider-text-values' },
            _react2.default.createElement(
              'div',
              { className: 'slider-text-values-sub' },
              _react2.default.createElement(
                'div',
                { className: 'slider-min-value' },
                _react2.default.createElement(
                  'span',
                  { className: 'price-currency' },
                  unit
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'price-bold' },
                  left
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'slider-max-value' },
                _react2.default.createElement(
                  'span',
                  { className: 'price-currency' },
                  unit
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'price-bold' },
                  '' + right + (this.state.values.right >= this.props.max ? '+' : '')
                )
              )
            )
          )
        )
      );
    }
  }]);
  return RangeSlider;
}(_react.Component);

RangeSlider.propTypes = {
  lang: _react.PropTypes.string.isRequired,
  title: _react.PropTypes.string.isRequired,
  unit: _react.PropTypes.string.isRequired,
  // the max/min boundary
  max: _react.PropTypes.number.isRequired,
  min: _react.PropTypes.number.isRequired,
  // the values of the handles
  high: _react.PropTypes.number,
  low: _react.PropTypes.number,
  isVisible: _react.PropTypes.bool,
  // onChange will be triggered when dragging ends
  onChange: _react.PropTypes.func
};

RangeSlider.defaultProps = {
  max: 100000,
  min: 1,
  onChange: function onChange() {}
};

exports.default = RangeSlider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RangeSlider.js
// module id = 1221
// module chunks = 0